<template>
	<div class="comment">
		<div class="parent-comment">
			<span class="comment-author-pic">
				<img
					v-if="author.node.avatar"
					:src="author.node.avatar.url"
					:width="author.node.avatar.size"
					alt=""
					height="60px"
				/>
				<img
					v-else
					src="https://secure.gravatar.com/avatar/e542236f92b493f9e48584763af17863?s=96&d=mm&r=g"
					alt=""
					height="60px"
					width="60px"
				/>
			</span>
			<div class="comment-container">
				<span class="comment-heading">
					<b>{{ author.node.name ?? "Anonymous" }}</b>
					<span class="hidden md:inline-block text-xs">&#9679;</span>
					<span class="comment-timestamp">{{ formatCommentDate(date) }}</span>
				</span>

				<CommentBody :content="contentFormatter(content)" />

				<div class="flex items-center gap-[8px]">
					<Button
						type="smallest"
						label="Reply"
						@click="onReply"
					/>
					<!-- <svg
            width="4"
            height="4"
            viewBox="0 0 2 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="1" cy="1.1875" r="1" fill="#98A2B3" />
          </svg> -->
					<!-- <Button type="smallest" label="Share" /> -->
					<!-- <svg width="4" height="4" viewBox="0 0 2 3" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1" cy="1.1875" r="1" fill="#98A2B3" />
          </svg>
          <span class="text-base font-regular text-slate-400">2 likes</span> -->
				</div>
			</div>
		</div>

		<div
			v-if="replies && replies.nodes && replies.nodes.length > 0"
			class="child-component"
		>
			<Comment
				v-for="childComment in replies.nodes"
				:key="childComment.commentId"
				v-bind="childComment"
			/>
		</div>
	</div>
</template>

<script setup>
import { load } from "cheerio";

const $route = useRoute();
const current_hostname = useRuntimeConfig().public.current_hostname;
const { commentId, author, date, replies, content } = defineProps({
	commentId: {
		type: Number,
		required: true
	},
	author: {
		type: Object,
		required: true
	},
	date: {
		type: String,
		required: true
	},
	replies: {
		type: Object,
		required: true
	},
	content: {
		type: String,
		required: true
	}
});

const onReply = () => {
	store.setCommentIdToReply({
		id: commentId,
		name: author.node.name ?? "Anonymous"
	});

	navigateTo(`${$route.path}#comments`);
};
const isValidURL = (url) => {
	const urlPattern = /^(https?):\/\/[^\s/$.?#].[^\s]*$/;
	return urlPattern.test(url);
};

const contentFormatter = (content) => {
	const $ = load(content, {
		decodeEntities: false, // Prevent HTML entity decoding
		xmlMode: false // Do not treat input as XML
	});

	$("a").each((_index, linkElement) => {
		let href = linkElement.attribs.href;
		let innerText = $(linkElement).text();

		const hostnames = [
			"https://sykescontenstg.wpenginepowered.com",
			"https://www.sykescontenstg.wpenginepowered.com",
			"https://www.timothysykes.com",
			"https://www.content.timothysykes.com",
			"https://content.timothysykes.com",
			"https://timothysykes.com"
		];

		hostnames.forEach((hostname) => {
			if (!isValidURL(href)) {
				// eslint-disable-next-line no-console
				console.error(`Invalid URL: ${href}`);
				return;
			}
			const url = new URL(href);
			const urlHostname = new URL(hostname);
			const matches = innerText.match(/(https?:\/\/[^\s]+)/g);

			if (url.origin === urlHostname.origin) {
				href = href.replace(url.origin, new URL(current_hostname).origin);
			}

			if (matches) {
				const urlText = new URL(innerText);
				if (urlText.origin === urlHostname.origin) {
					innerText = current_hostname + innerText.split(".com/")[1];
				}
			}
		});

		$(linkElement).text(innerText);

		$(linkElement).attr("href", href);

		if (
			linkElement.attribs.href &&
			!linkElement.attribs.href.includes("#") &&
			$(linkElement).find("img").length === 0
		) {
			$(linkElement).addClass("external-link");
		}
	});

	return $.html();
};
</script>

<style lang="scss">
@import "@assets/utils.scss";

.comment {
	width: 100%;
}

.child-component {
	width: 100%;
	margin-top: 20px;
	padding-left: 24px;
	@include breakpoint(md) {
		margin-top: 24px;
		padding-left: 36px;
	}
}

.parent-comment {
	display: flex;
	gap: 8px;
	align-items: flex-start;
	max-width: 620px;
}

.comments-container {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	@include breakpoint(md) {
		// gap: 40px;
	}
}

.comment-container p {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 16px;
	width: 100%;
	white-space: normal;
	display: inline-block;
	word-wrap: break-word;
	&:last-child {
		margin-bottom: 0;
	}

	a {
		color: $primary-500;
		text-decoration: underline;
		white-space: normal;
		word-wrap: break-word;
	}
}

.comment-timestamp {
	color: $neutral-600;
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
}

.comment-heading {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	letter-spacing: 0.18px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	@include breakpoint(md) {
		flex-direction: row;
		gap: 8px;
	}
	span {
		width: 100%;
		&:last-child {
			margin-bottom: 12px;
		}
		@include breakpoint(md) {
			width: auto;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}

.comment-author-pic {
	width: 40px;
	height: 40px;
	min-width: 40px;
	min-height: 40px;
	max-width: 40px;
	max-height: 40px;
	overflow: hidden;
	display: block;
	border-radius: 32px;
	@include breakpoint(md) {
		width: 60px;
		height: 60px;
		min-width: 60px;
		min-height: 60px;
		max-width: 60px;
		max-height: 60px;
	}
}

.parent-comment {
	background-color: white;
	width: 100%;
	display: flex;
	padding: 12px;
	border-radius: 8px;
}
</style>
